import React from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { ProblemSolution } from "../components/ProblemSolution";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { VideoTestimonials } from "../components/VideoTestimonials";
import { Process } from "../components/Process";
import { About } from "../components/About";
import { FAQ } from "../components/FAQ";
import { LeadForm } from "../components/LeadForm";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-[#1A1A2E] text-white">
      <Navbar />
      <Hero />
      <ProblemSolution />
      <Services />
      <Portfolio />
      <VideoTestimonials />
      <Process />
      <About />
      <FAQ />
      <LeadForm />
      <Footer />
    </main>
  );
}
